/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_CancelledInputs */

const en_so_status_cancelled = /** @type {(inputs: So_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {So_Status_CancelledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_cancelled = /** @type {((inputs?: So_Status_CancelledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_CancelledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_cancelled(inputs)
});